import React, { useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";
import encryptionService from "../../../services/encryptionService";

const Menuentry = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "menu-entry";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();

  const { useState } = React;
  const [dataItems, setDataItems] = useState([]);

  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const { isLoading, error, isError, data, refetch } = useQuery(["menuentry"],
    api.getmenuEntry,
    {
      onSuccess: (data) => {
        setDataItems(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );
  const { mutate: deleteApi } = useMutation(api.deletemenu, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        api.getDispensingLanguage().then((response) => {
          localStorage.setItem(
            "DispensingLanguage",
            JSON.stringify(response.datalist)
          );
        });

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
        refetch();
        queryClient.getQueriesData("menuentry");
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

    window.open(
      finalUrl +
        "?action=PacksizeExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editmenu(rowData);
  };

  const columns = [
    { title: "Id", field: "id", width: 50, visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      formatter: "rownum",
      width: 80,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Menu Name"]),
      headerFilter: true,
      field: "menuname",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Menu Url"]),
      headerFilter: true,
      field: "url",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Menu Position"]),
      headerFilter: true,
      field: "position",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Menu MenuLevel"]),
      headerFilter: true,
      field: "MenuLevel",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      width: 133,
      headerSort: false,
      headerHozAlign: "center",
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editmenu = (data) => {
    let route = `menu-entry/edit/${data.id}`;
    props.history.push(route);
  };

  const deletemenu = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Record!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteApi({
          id: data.id,
          menukey: menukey,
          lan: lan,
          UserName: UserName,
          action: "dataDalete",
        });
      }
    });
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              editmenu(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              editmenu(rowData);
            }}
          />
          <DeleteOutline
            onClick={() => {
              deletemenu(rowData);
            }}
          />
        </>
      );

    /* return (
      <>
        <Edit
          onClick={() => {
            editmenu(rowData);
          }}
        />
        <DeleteOutline
          onClick={() => {
            deletemenu(rowData);
          }}
        />
      </>
    ); */
  }

  return (
    <>
      <div className={classes.packSizePageTitle}>
        <div className="d-flex justify-packSize mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Menu Entry Form"]}
              </div>
              <div className="float-end sw_btn_control">
                <Button
                  disabled={!!props.permissionType}
                  color="info"
                  className="me-2"
                  onClick={() => {
                    props.history.push("/menu-entry/shortorder");
                  }}
                >
                  {DispensingLanguage[lan][menukey]["Change Order"]}
                </Button>

                <Button
                  disabled={!!props.permissionType}
                  color="info"
                  className="me-2"
                  onClick={() => {
                    props.history.push("/menu-entry/add");
                  }}
                >
                  {DispensingLanguage[lan][menukey]["Add Menu"]}
                </Button>
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        <div>
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              height={600}
              layout={"fitColumns"}
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Menuentry;

const useStyles = makeStyles({
  packSizePageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
